/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

import '../assets/css/style.css'
import lifeevent from '../assets/img/rougo/image_1.svg'
import hitsuyosei from '../assets/img/rougo/text_1.svg'
import dummy from '../assets/img/rougo/image_2.svg'
import visit from '../assets/img/rougo/image_3_1.svg'
import reform from '../assets/img/rougo/image_3_2.svg'
import sports from '../assets/img/rougo/image_3_3.svg'
import medicalCost from '../assets/img/rougo/image_3_5.svg'
import karioki from '../assets/img/rougo/image_5.svg'
import titleRougo from '../assets/img/title/title_rougo.svg'
import { Link } from 'react-router-dom'
import { Header } from '../components/header'
import { Footer } from '../components/footer'
import { useHeadTitle } from '../hook/useHeadTitle'
import { useDealerCodeUrl } from '../hook/useDealerCode'
import { useDescription } from '../hook/useDescription'

export default function Rougo() {
  useHeadTitle('今こそ資産運用を考えよう', '老後資金')
  useDescription(
    '資産運用について知っておきたい基本とコツ。野村アセットマネジメントが資産運用に取り組む皆さまをサポートします。'
  )
  return (
    <React.Fragment>
      <Header />
      <main>
        <section>
          <div className="c-title-wrap">
            <h2 className="c-title--primary">
              <span className="c-title__balloon">
                <span>何から始めればいいの？</span>
              </span>
              <img src={titleRougo} alt="老後資金" />
            </h2>
          </div>

          <section>
            <div className="u-bg--white">
              <div className="p-rougo__intro">
                <div className="p-rougo__intro__img">
                  <img src={lifeevent} alt="" />
                </div>
                <div className="p-rougo__intro__text">
                  <h3 className="u-mb20px">
                    <img src={hitsuyosei} alt="老後の蓄えの必要性" />
                  </h3>
                  <p>
                    人生には様々なイベントごとにお金がかかります。中でも老後のための資金は、期間が長いだけに多額になります。
                    このため、他のライフイベントのための貯蓄とは別に、早くから計画的に準備をしていくことが大切です。
                  </p>
                </div>
              </div>
            </div>
          </section>

          <div className="l-container">
            <div className="u-pt60px">
              <section className="c-box">
                <h3 className="c-box__head">
                  <span className="c-box__head__title">老後の生活費</span>
                </h3>
                <div className="p-rougo__box-body">
                  <p className="p-rougo__lead">
                    ゆとりあるセカンドライフを送るためには、月額約39万円が必要になります。
                    年金だけでは不足してしまうようです。
                  </p>
                  <section>
                    <h4 className="c-heading-1 u-mt33px">ゆとりあるセカンドライフにかかるお金</h4>
                    <p className="u-text--center">
                      <img src={dummy} alt="ゆとりあるセカンドライフにかかるお金" />
                    </p>
                    <ol className="c-note--ol u-mt20px">
                      <li>
                        夫婦2人分の老齢基礎年金を含む標準的な年金額（出所）厚生労働省「令和6年度の年金額」（
                        <a href="https://www.mhlw.go.jp/" target="_blank" rel="noopener noreferrer">
                          https://www.mhlw.go.jp/
                        </a>
                        ）
                      </li>
                      <li>
                        夫婦ふたり（出所）生命保険文化センター「2022年（令和4）年度
                        生活保障に関する調査」
                      </li>
                    </ol>
                  </section>
                  <section>
                    <h4 className="c-heading-1 u-mt63px">ゆとりある生活にかける予算例</h4>
                    <ul className="p-rougo__img-grid u-mb30px">
                      <li className="p-rougo__img-grid__unit--2col">
                        <p>
                          <img src={visit} alt="ゆとりある生活にかける予算例：旅行" />
                        </p>
                        <p className="c-note u-mt10px">
                          （出所）国土交通省「旅行・観光消費動向調査（2022年）」（
                          <a
                            href="https://www.mlit.go.jp/kankocho/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            https://www.mlit.go.jp/kankocho/
                          </a>
                          ）
                        </p>
                      </li>
                      <li className="p-rougo__img-grid__unit--2col">
                        <p>
                          <img src={reform} alt="ゆとりある生活にかける予算例：住宅リフォーム" />
                        </p>
                        <p className="c-note u-mt10px">
                          （出所）国土交通省「建築物リフォーム・リニューアル調査（2022年度）」 （
                          <a
                            href="https://www.mlit.go.jp/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            https://www.mlit.go.jp/
                          </a>
                          ）を基に野村アセットマネジメント作成
                        </p>
                      </li>
                    </ul>
                    <ul className="p-rougo__img-grid u-mb30px">
                      <li className="p-rougo__img-grid__unit--2col">
                        <p>
                          <img src={sports} alt="ゆとりある生活にかける予算例：教養娯楽" />
                        </p>
                        <p className="c-note u-mt10px">
                          （出所）総務省統計局「家計調査結果（2023年平均）」 （
                          <a
                            href="https://www.stat.go.jp/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            https://www.stat.go.jp/
                          </a>
                          ）を基に野村アセットマネジメント作成
                        </p>
                      </li>
                    </ul>
                    <ul className="p-rougo__img-grid">
                      <li>
                        <p className="u-text--center">
                          <img
                            src={medicalCost}
                            alt="ゆとりある生活にかける予算例：介護費用、保険医療"
                          />
                        </p>
                        <p className="c-note u-mt10px">
                          （出所）生命保険文化センター「2021（令和3）年度
                          生命保険に関する全国実態調査」、総務省統計局「家計調査結果(2023年平均)」（
                          <a
                            href="https://www.stat.go.jp/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            https://www.stat.go.jp/
                          </a>
                          ）、各種データを基に野村アセットマネジメント作成
                          <br />
                          介護費用：介護を始めてからの期間（介護中の場合は経過期間）は平均約5年1ヵ月（61.1ヵ月）。月額8.3万円×介護期間61.1ヵ月+一時費用74.4万円。
                          <br />
                          保健医療：年間/夫婦ふたり（夫65歳以上、妻60歳以上の夫婦一組の無職世帯）
                          <br />
                          注：図表の数字は、四捨五入している場合があります。
                        </p>
                      </li>
                    </ul>
                  </section>
                </div>
              </section>
            </div>
          </div>

          <div className="l-container">
            <div className="u-pt60px">
              <section className="c-box">
                <h3 className="c-box__head">
                  <span className="c-box__head__title">
                    お金に働いてもらう資産運用を考えてみませんか？
                  </span>
                </h3>
                <div className="p-rougo__box-body">
                  <p className="p-rougo__lead">
                    退職時の退職金を2,200万円<sup>※1</sup>
                    とし、ゆとりある生活への毎月の不足額、約16万円（年間192万円）を取り崩していくと、運用しなかった場合は11年ほどでゆとりある生活は終わってしまいます。
                    <br />
                    さらに物価が上昇した場合、お金の実質的価値が目減りするため、ゆとりある生活を送ることができる期間は10年ほどに短くなってしまいます。
                  </p>
                  <p className="u-text--center u-mt40px">
                    <img src={karioki} alt="お金に働いてもらう資産運用を考えてみませんか？" />
                  </p>
                  <div className="u-mt12px u-pl60px u-pr60px">
                    <ol className="c-note--ol">
                      <li>
                        厚生労働省「令和3年賃金事情等総合調査－退職金、年金及び定年制事情調査」（
                        <a href="https://www.mhlw.go.jp/" target="_blank" rel="noopener noreferrer">
                          https://www.mhlw.go.jp/
                        </a>
                        ）より、調査産業計・満勤勤続・大学卒・男性平均退職金額
                        2,230万円（令和2年度）を参考とし、2,200万円と仮定。
                      </li>
                      <li>
                        厚生労働省「令和4年簡易生命表」（
                        <a href="https://www.mhlw.go.jp/" target="_blank" rel="noopener noreferrer">
                          https://www.mhlw.go.jp/
                        </a>
                        ）、60歳男性の平均余命23.6年（83.6歳）、60歳女性の平均余命28.8年（88.8歳）より。
                      </li>
                    </ol>
                    <p className="c-note">
                      上記データを基に毎年、年末に192万円ずつ取り崩していったと仮定し、野村アセットマネジメントが算出したシミュレーション結果であり、
                      将来の投資成果を示唆あるいは保証するものではありません。算出過程で取引コスト等は考慮しておりません。
                      <br />
                      （作成）野村アセットマネジメント
                    </p>
                  </div>
                </div>
              </section>
            </div>

            <div className="u-mt70px u-text--center p-rougo__button">
              <Link
                to={useDealerCodeUrl('/rougoSimulation')}
                className="c-button--secondary c-button-arrow--next"
              >
                <span className="c-button__text--m u-mr24px">老後資金シミュレーションはこちら</span>
              </Link>
            </div>
          </div>
        </section>

        <div className="u-bg--white u-mt60px">
          <div className="c-button-group">
            <Link to={useDealerCodeUrl('/')} className="c-button--primary c-button-arrow--back">
              <span className="c-button__text--xs">TOPページへ戻る</span>
            </Link>
            <Link
              to={useDealerCodeUrl('/kyouiku')}
              className="c-button--primary c-button-arrow--next"
            >
              <span className="c-button__text--xs u-mr10px">教育資金へ進む</span>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </React.Fragment>
  )
}
